import { render, staticRenderFns } from "./DaftarPerusahaan.vue?vue&type=template&id=e1c6d6c2&scoped=true"
import script from "./DaftarPerusahaan.vue?vue&type=script&lang=js"
export * from "./DaftarPerusahaan.vue?vue&type=script&lang=js"
import style0 from "./DaftarPerusahaan.vue?vue&type=style&index=0&id=e1c6d6c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1c6d6c2",
  null
  
)

export default component.exports